import { render, staticRenderFns } from "./CMSPageForm.vue?vue&type=template&id=56530568&scoped=true&"
import script from "./CMSPageForm.vue?vue&type=script&lang=js&"
export * from "./CMSPageForm.vue?vue&type=script&lang=js&"
import style0 from "./CMSPageForm.vue?vue&type=style&index=0&id=56530568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56530568",
  null
  
)

export default component.exports